<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 shape-primary alpha-4">
      <span />
      <span />
      <span />
      <span />
      <span />
      <span />
      <span />
      <span />
    </div>
    <div class="container container-lg pt-5">
      <card shadow>
        <div class="search-noresults">
          <section class="normal markdown-section">
            <div class="display-4 mb-4">ClashX（推荐）</div>
            <ul>
              <li>
                <code>系统要求：macOS 10.12 及以上</code>
              </li>
              <li>
                <code>设备要求：MacBook / iMac / Mac Pro</code>
              </li>
            </ul>
            <div class="display-4 mt-4 mb-4">介绍</div>
            <p>
              ClashX是个适用于V2Ray的图形化客户端，内核Clash整合了V2Ray，并具有强大的路由功能。本站目前支持Clash的订阅托管模式
            </p>
            <div class="display-4 mt-4 mb-4">下载</div>
            <p>版本:v1.98.0 | 更新日期: 2023-05-14</p>
            <p>
              <a
                href="https://staticn.oss-cn-beijing.aliyuncs.com/clashx/1.98.0/ClashX.dmg"
                target="_blank"
              >本地下载</a
              >
              |
              <a
                href="https://github.com/yichengchen/clashX/releases/download/1.72.0/ClashX.dmg"
                target="_blank"
              >官方下载</a
              >
            </p>
            <h2 id="运行">运行</h2>
            <ul>
              <li>双击您下载的文件，将ClashX拖动到Lunchpad或任意位置。</li>
              <li>第一次安装可能会需要输入当前用户密码</li>
              <li>点击运行ClashX</li>
            </ul>
            <!-- <h2 id="配置订阅并开启clashx">配置订阅并开启ClashX</h2>
            <ul>
              <li>
                进入您的
                <a href="https://sstz.info" target="_blank">产品中心</a>，点击对应套餐进入套餐详情，用户信息区域，订阅区域点击
                <strong>Clash订阅链。</strong>
              </li>
            </ul>

            <p>
              <img src="/img/client/pc.png" alt >
            </p>
            <p>
              <img src="/img/client/pc-clash.png" alt >
            </p> -->
            <div class="display-4 mt-4 mb-4">订阅信息</div>
            <div v-if="accounts.length">
              <div
                v-for="account in accounts"
                :key="account._id"
                class="sub-item mb-2"
              >
                <div class="display-6 mt-2 mb-2">
                  {{ account.product.title }}
                </div>
                <base-button
                  class="mr-3"
                  size="sm"
                  type="primary"
                  @click="
                    handleCopy(
                      `${subLinks_1}/v1/api/clash/${
                        account.subscription || account._id
                      }`,
                      $event
                    )
                  "
                >点我复制订阅连接1</base-button
                >
                <base-button
                  size="sm"
                  type="primary"
                  @click="
                    handleCopy(
                      `${subLinks_2}/v1/api/clash/${
                        account.subscription || account._id
                      }`,
                      $event
                    )
                  "
                >点我复制订阅连接2</base-button
                >
              </div>
            </div>
            <div v-else>
              <h2 class="display-4" style="font-size: 1.2rem">
                你还没有套餐，
                <router-link
                  :to="{ name: 'dashboard-plan' }"
                >立即购买</router-link
                >
              </h2>
            </div>
            <div class="display-4 mt-4 mb-4">订阅设置</div>
            <ul>
              <li>点击上面的按钮，复制订阅连接</li>

              <li>
                打开ClashX，点击顶部菜单栏ClashX图标，配置 - 托管配置 - 设置地址
              </li>
            </ul>
            <p>
              <img src="/img/client/macos/clashx/01.png" alt >
            </p>
            <ul>
              <li>
                跳出窗口中，点击添加按钮，在弹出的对话框中粘贴刚才复制的Clash订阅链，确定保存
              </li>
            </ul>
            <p>
              <img src="/img/client/macos/clashx/02.png" alt >
            </p>
            <ul>
              <li>
                确定保存，导入成功后会增加一条订阅连接记录，点击更新，导入成功后会显示Success
              </li>
            </ul>
            <p>
              <img src="/img/client/macos/clashx/04.png" alt >
            </p>
            <ul>
              <li>
                在Proxy里应该能看到所有节点了，点击延迟测速，如下图出现延迟ms数字即配置成功！
              </li>
            </ul>
            <p>
              <img src="/img/client/macos/clashx/05.png" alt >
            </p>
            <ul>
              <li>按需求任意选择。同时勾选设为系统代理，显示事实速率！</li>
              <li>
                如后面出现fail ,则检查系统时间是否准确！系统时间不可以误差
                +-10秒！
              </li>
            </ul>
            <p>
              <img src="/img/client/macos/clashx/06.png" alt >
            </p>
            <ul>
              <li>
                设置出站模式（规则）
                <ul>
                  <li>全局：所有流量都经过加速服务器</li>
                  <li>
                    规则：只有海外流量会经过加速服务器，并且包含了部分去广告去隐私跟踪规则
                  </li>
                  <li>直连：所有流量都不经过加速服务器</li>
                </ul>
              </li>
            </ul>
            <p>
              <img src="/img/client/macos/clashx/image%20%2833%29.png" alt >
            </p>
            <h2 id="已知问题">已知问题</h2>
            <p>
              极少数用户安装后订阅时显示config文件不存在，估计由于权限问题导致ClashX安装时无法正确创建运行所需文件夹，解决办法如下：
            </p>
            <ul>
              <li>退出ClashX，打开令行工具（Lunchpad-&gt;其他-&gt;终端）</li>
            </ul>
            <p>
              <img src="/img/client/macos/clashx/image%20%284%29.png" alt >
            </p>
            <ul>
              <li>输入以下命令</li>
            </ul>
            <pre
              style="text-align: left"
            >cd <br >mkdir  .config <br >mkdir .config/clash</pre>
            <p>
              <img src="/img/client/macos/clashx/image%20%2832%29.png" alt >
            </p>
            <ul>
              <li>重启ClashX即可解决此问题</li>
            </ul>
          </section>
        </div>
      </card>
    </div>
  </section>
</template>
<script>
import { mapActions } from 'vuex'
import clip from '@/utils/clipboard'
export default {
  data() {
    return {
      loading: false
    }
  },
  computed: {
    accounts() {
      return this.$store.state.server.account
    },
    subLinks_1() {
      return this.$store.state.subLinks_1
    },
    subLinks_2() {
      return this.$store.state.subLinks_2
    }
  },
  mounted() {
    this.loading = true
    this.getAccounts().then((res) => {
      this.loading = false
    })
  },
  methods: {
    ...mapActions(['getAccounts']),
    handleCopy(text, event) {
      clip(text, event)
    }
  }
}
</script>
<style scoped>
.search-noresults img {
  max-width: 100%;
}
/* @media only screen and (min-width: 600px) {
 .search-noresults img {
    max-width: 100%;
  }
} */
@media only screen and (min-width: 768px) {
  .search-noresults img {
    max-width: 60%;
  }
}
</style>
